import styled from 'styled-components';

import { media } from '../../../../helpers/breakpoints';
import { Text } from '../../../../components/ToolkitV2/Text/Text';

export const Wrapper = styled.div`
  padding: ${({ theme }) => theme.spacing.M16};
  background-color: ${({ theme }) => theme.colors.OFFWHITE};
  border-radius: ${({ theme }) => theme.borderRadius.default};
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.S8};

  ${media.medium} {
    gap: ${({ theme }) => theme.spacing.M16};
  }
`;

export const Item = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Disclaimer = styled(Text)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.S8};
`;
